import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { generateChecksum } from '../middleware/generateChecksum';

export const fileApi = createApi({
    reducerPath: 'fileApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + '/v2/api/',
    }),
    endpoints: (builder) => ({
        updateFile: builder.mutation({
            query: (data) => {
                const body = {
                    mode: 'document_upload',
                    document_field: 'other',
                    document_name: data.document_name,
                    document_string: data.document_string
                }
                const checksum = generateChecksum(body)
                body.checksum = checksum

                return {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: 'application/json',
                        secret: data.scrt,
                        jwt_token: data.jwt_token,
                    },
                    body: new URLSearchParams(body).toString(),
                }
            },
        })
    }),
});

export const {
    useUpdateFileMutation,
} = fileApi;
